<div class="modal-header">
  <h4 class="modal-title" i18n>Privacy policy</h4>
  <button *ngIf="!noClose && activeModal" type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <div class="row g-3">
    <div *ngIf="privacyPolicy" class="col-md-12" [innerHTML]="privacyPolicy | translateField: 'privacy_policy'">
    </div>
  </div>
</div>
<div *ngIf="!noClose && activeModal" class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>